import _ from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { ParentContext } from '../cnr/contexts/ParentContext';
import { TopicContext } from '../cnr/contexts/TopicContext';
import { uniqueKey } from '../common/keys';
import { gEnums } from '../enums/globalEnums';
import { buildFcmPayload } from '../functions/fbNotifications';
import ItemMenuSquares from 'global/wrappers/ItemMenuSquares';
import { _fcmTopicKeys, useFcm } from 'global/cnr/contexts/useHelpers/useFcm';
import { useFcmSubscribe } from 'global/cnr/contexts/useHelpers/useFcmSubscribe';

const _fcActionTypes = {
  send: 'send',
  delete: 'delete',
}

const _fcmTopicTypes = {
  subscribe_topic: 'subscribe_topic',
  unsubscribe_topic: 'unsubscribe_topic',
  send_topic: 'send_topic'
}

const _fcmAuthTypes = {
  subscribe_auth: 'subscribe_auth',
  unsubscribe_auth: 'unsubscribe_auth',
  send_auth: 'send_auth'
}

const _fcmErrorTypes = {
  subscribe_error: 'subscribe_error',
  unsubscribe_error: 'unsubscribe_error',
  send_error: 'send_error'
}

const _appUserDashboardTypes = {
  ..._fcActionTypes,
  ..._fcmAuthTypes,
  ..._fcmTopicTypes,
  ..._fcmErrorTypes,
}

const _sendTypes = {
  error: 'error',
  sending: 'sending',
  sent: 'sent',
}

const _labelSize = 'large'

const WAIT_INTERVAL = 3000

const SquaresFcm = (props) => {

  const { selectedAppUser } = props
  const { fcmTokens, _itemKey } = selectedAppUser ?? {}

  const parentContext = useContext(ParentContext);
  const { states, handlers } = parentContext ?? {}
  const { paps_state, currentSettings_state } = states ?? {}
  const { pathViews } = paps_state ?? {}

  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { topMenu } = aps_global ?? {}
  const { mainFixedCaption } = topMenu ?? {}

  // topicContext
  const topicContext = useContext(TopicContext);
  const { topic_state, topic_handlers } = topicContext ?? {}
  const { dbTopics, topicSubscriptions, pending, updating } = topic_state ?? {}

  const { sendFcm_payload, fcmResponse } = useFcm()
  const { handleSubscribe_toTopic, subscribeResponse } = useFcmSubscribe()

  const [subsribedTopics, setSubsribedTopics] = useState()
  const [currentSending, setCurrentSending] = useState({})
  const [currentSubscribing, setCurrentSubscribing] = useState({})

  const itemRefs = useRef([]);

  useEffect(() => {
    if (fcmResponse) {
      const { result, fcmPayload } = fcmResponse ?? {}
      const { success } = result ?? {}
      const _currentSending = _.cloneDeep(currentSending)
      _currentSending.type = success ? _sendTypes.sent : _sendTypes.error
      setCurrentSending(_currentSending)
      const timer = setTimeout(() => {
        setCurrentSending();
      }, WAIT_INTERVAL);
      return () => clearTimeout(timer); // cleanup
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fcmResponse]);

  useEffect(() => {
    if (subscribeResponse) {
      const { result } = subscribeResponse ?? {}
      const { success } = result ?? {}
      const _currentSubscribing = _.cloneDeep(currentSubscribing)
      _currentSubscribing.type = success ? _sendTypes.sent : _sendTypes.error
      setCurrentSubscribing(_currentSubscribing)
      const timer = setTimeout(() => {
        setCurrentSubscribing();
      }, WAIT_INTERVAL);
      return () => clearTimeout(timer); // cleanup
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscribeResponse]);

  useEffect(() => {
    if (fcmTokens) {
      const _subscribedTopics = {}
      Object.keys(gEnums.adminTopicTypes).forEach(k => {
        const _selectedDbTopic = dbTopics ? dbTopics[k] : {}
        const { fcmTokens: selectedFcmTokens } = _selectedDbTopic ?? {}
        let _userIsSubscribed = true
        if (selectedFcmTokens) {
          Object.keys(fcmTokens).forEach(k => {
            const fcmToken = fcmTokens[k]
            if (!selectedFcmTokens.includes(fcmToken.tokenKey)) {
              _userIsSubscribed = false
            }
          })
        } else {
          _userIsSubscribed = false
        }
        _subscribedTopics[k] = _userIsSubscribed
      })
      setSubsribedTopics(_subscribedTopics)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fcmTokens, dbTopics]);

  useEffect(() => {
    if (pending && pending.result) {
      const timer = setTimeout(() => topic_handlers.handlePending_clear(), WAIT_INTERVAL);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pending]);

  const handleSubscribe = (e, topic) => {
    e.stopPropagation()
    topic_handlers.handlePending_start({ type: 'subscribing', key: topic })
    topic_handlers.handleSubscribe(topic, fcmTokens, subsribedTopics[topic])
  }

  const handleSendFcm = (mt) => {

    let _toTopic = false;
    let _title = mainFixedCaption;
    let _topicKey = null;
    let _body = 'This is just a DIRECT TOKEN test from ' + mainFixedCaption

    switch (mt) {
      case _appUserDashboardTypes.send:
        // keep the original
        break;
      case _appUserDashboardTypes.send_auth:
        _toTopic = true
        _title += ': AUTH Test'
        _topicKey = _fcmTopicKeys.auth
        _body = 'This is just an AUTH TOPIC test from ' + mainFixedCaption
        break;
      case _appUserDashboardTypes.send_error:
        _toTopic = true
        _title += ': ERROR Test'
        _topicKey = _fcmTopicKeys.error
        _body = 'This is just an ERROR TOPIC test from ' + mainFixedCaption
        break;
      case _appUserDashboardTypes.send_topic:
        _toTopic = true
        _title += ': TOPIC Test'
        _topicKey = _fcmTopicKeys.generic
        _body = 'This is just an GENERIC TOPIC test from ' + mainFixedCaption
        break;
    }

    const notificationData = { title: 'Test', body: _body }
    if (pathViews.clients) { notificationData.clientKey = pathViews.clients }
    if (pathViews.events) { notificationData.eventKey = pathViews.events }

    const _tokens = _.map(fcmTokens, item => item.tokenKey);
    const fcmPayload = (topic, title, body) => buildFcmPayload(topic ? null : _tokens, topic, title ? title : 'FCM Test', body ? body : _body)
    const payload = fcmPayload(_topicKey, _title, _body)

    setCurrentSending({ payload, _topicKey, audt: mt, type: _sendTypes.sending })

    sendFcm_payload(payload)
  }

  const handleSubscribeFcm = (mt, topicKey, unsubscribe) => {
    setCurrentSubscribing({ topicKey, audt: mt, type: _sendTypes.sending })
    _.forEach(fcmTokens, (fcmToken) => {
      handleSubscribe_toTopic(fcmToken.tokenKey, topicKey, unsubscribe, _itemKey)
    })
  }

  const handleClearFcm = (e, tokenType, tokenKey) => {
    e.stopPropagation()
    topic_handlers.handlePending_start({ type: 'clearing', key: tokenKey })
    const _fcmTokens = fcmTokens ? { ...fcmTokens } : {}
    delete _fcmTokens[tokenType]
    topic_handlers.handleClear_fcm(selectedAppUser._itemKey, _fcmTokens, tokenType, tokenKey)
  }

  const ammendLblProps = (lblProps, pending) => {
    lblProps.disabled = true
    if (pending.result) {
      if (pending.result === 'SUCCESS') {
        lblProps.color = 'green'
        lblProps.icon = 'check'
      } else {
        lblProps.color = 'black'
        lblProps.icon = 'ban'
      }
    } else {
      lblProps.color = 'teal'
      lblProps.icon = 'spinner'
      lblProps.loading = true
    }
  }

  const topicListItems = () => Object.keys(gEnums.adminTopicTypes).map(topic => {
    const lblProps = subsribedTopics[topic] ? { color: 'blue', icon: 'check circle' } : { color: 'grey', icon: 'circle outline' }
    if (updating && pending && pending.type === 'subscribing' && pending.key === topic) {
      ammendLblProps(lblProps, pending)
    }
    return <Label key={uniqueKey('fcm', 'tli', topic)} size='tiny' color={lblProps.color} onClick={(e) => !lblProps.disabled && handleSubscribe(e, topic)} > <Icon name={lblProps.icon} loading={lblProps.loading} />{_.startCase(topic)}</Label>
  })

  const hc_appUsers = (item) => {
    const mt = item?.key
    switch (mt) {
      case _appUserDashboardTypes.send:
      case _appUserDashboardTypes.send_auth:
      case _appUserDashboardTypes.send_error:
      case _appUserDashboardTypes.send_topic:
        handleSendFcm(mt)
        break;

      case _appUserDashboardTypes.delete:
        handleClearFcm()
        break;

      case _appUserDashboardTypes.subscribe_auth:
        handleSubscribeFcm(mt, _fcmTopicKeys.auth)
        break;

      case _appUserDashboardTypes.unsubscribe_auth:
        handleSubscribeFcm(mt, _fcmTopicKeys.auth, true)
        break;

      case _appUserDashboardTypes.subscribe_error:
        handleSubscribeFcm(mt, _fcmTopicKeys.error)
        break;

      case _appUserDashboardTypes.unsubscribe_error:
        handleSubscribeFcm(mt, _fcmTopicKeys.error, true)
        break;

      case _appUserDashboardTypes.subscribe_topic:
        handleSubscribeFcm(mt, _fcmTopicKeys.generic)
        break;

      case _appUserDashboardTypes.unsubscribe_topic:
        handleSubscribeFcm(mt, _fcmTopicKeys.generic, true)
        break;
    }
  }

  const squareText = (key) => {
    switch (key) {
      case _appUserDashboardTypes.other:
        return _.startCase(key)
      default:
        return _.startCase(key)
    }
  }

  const squareCaption = (key, caption) => {
    let isSubscribed = false
    if (fcmTokens && topicSubscriptions?.[key]) {
      _.forEach(fcmTokens, (fcmToken) => {
        if (_.includes(topicSubscriptions?.[key], fcmToken.tokenKey)) {
          isSubscribed = true
        }
      })
    }
    return isSubscribed ? `${caption}: (subscribed)` : caption
  }

  const squareIcon = (key) => {

    if (currentSending?.audt === key) {
      if (currentSending.type === _sendTypes.sending) {
        return { icon: 'cog', iconColor: 'pink' }
      } else if (currentSending.type === _sendTypes.sent) {
        return { icon: 'check', iconColor: 'green' }
      } else if (currentSending.type === _sendTypes.error) {
        return { icon: 'ban', iconColor: 'red' }
      }
    }

    if (currentSubscribing?.audt === key) {
      if (currentSubscribing.type === _sendTypes.sending) {
        return { icon: 'cog', iconColor: 'pink' }
      } else if (currentSubscribing.type === _sendTypes.sent) {
        return { icon: 'check', iconColor: 'green' }
      } else if (currentSubscribing.type === _sendTypes.error) {
        return { icon: 'ban', iconColor: 'red' }
      }
    }

    switch (key) {
      case _appUserDashboardTypes.send:
      case _appUserDashboardTypes.send_auth:
      case _appUserDashboardTypes.send_topic:
      case _appUserDashboardTypes.send_error:
        return { icon: 'send', iconColor: 'green' }
      case _appUserDashboardTypes.delete:
        return { icon: 'ban', iconColor: 'red' }
      case _appUserDashboardTypes.subscribe_auth:
      case _appUserDashboardTypes.subscribe_topic:
      case _appUserDashboardTypes.subscribe_error:
        return { icon: 'sign-in', iconColor: 'blue' }
      case _appUserDashboardTypes.unsubscribe_auth:
      case _appUserDashboardTypes.unsubscribe_error:
      case _appUserDashboardTypes.unsubscribe_topic:
        return { icon: 'sign-out', iconColor: 'red' }
      default:
        return { icon: 'settings', iconColor: 'grey' }
    }
  }

  const ims_fcmAction = () => {
    const mis = _.mapValues(_.keyBy(_fcActionTypes), (v) => ({
      caption: squareText(v),
      ...squareIcon(v),
      // selected: v === selectedListType,
    }));
    return <ItemMenuSquares caption={'Actions'} menuItems={mis} onClick={hc_appUsers} icon={'users'} />
  }

  const ims_fcmTopic = () => {
    const mis = _.mapValues(_.keyBy(_fcmTopicTypes), (v) => ({
      caption: squareText(v),
      ...squareIcon(v),
      // selected: v === selectedListType,
    }));
    return <ItemMenuSquares caption={squareCaption(_fcmTopicKeys.generic, 'Topics')} menuItems={mis} onClick={hc_appUsers} icon={'users'} />
  }

  const ims_fcmAuth = () => {
    const mis = _.mapValues(_.keyBy(_fcmAuthTypes), (v) => ({
      caption: squareText(v),
      ...squareIcon(v),
      // selected: v === selectedListType,
    }));
    return <ItemMenuSquares caption={squareCaption(_fcmTopicKeys.auth, 'Auth')} menuItems={mis} onClick={hc_appUsers} icon={'users'} />
  }

  const ims_fcmError = () => {
    const mis = _.mapValues(_.keyBy(_fcmErrorTypes), (v) => ({
      caption: squareText(v),
      ...squareIcon(v),
      // selected: v === selectedListType,
    }));
    return <ItemMenuSquares caption={squareCaption(_fcmTopicKeys.error, 'Errors')} menuItems={mis} onClick={hc_appUsers} icon={'users'} />
  }

  const fcmList = () => {
    if (fcmTokens) {
      return <div style={{ display: 'flex', gap: '1em', flexDirection: 'column' }}>
        <div style={{ padding: '1em', color: 'white', textAlign: 'center', backgroundColor: 'var(--off-black-2' }}>{`FCMs: ${_.size(fcmTokens)}`}</div>
        {ims_fcmAction()}
        {ims_fcmAuth()}
        {ims_fcmTopic()}
        {ims_fcmError()}
      </div>
    } else {
      return <div style={{ padding: '1em' }}>{'No FCM Tokens'}</div>
    }
  }

  return <div>
    {fcmList()}
    {/**/}
    <div>
      {subsribedTopics && topicListItems()}
    </div>
  </div>

}

export default SquaresFcm 